import i18n from "../i18n";
import { trackEvent, WHATSAPP_VALUE_CHF, CURRENCY } from "./analytics";

export const WHATSAPP_NUMBER = "41764684773";

/** Build a wa.me URL with a localized default message. */
export const buildWhatsAppUrl = (extraText = "") => {
  const base = i18n.t(
    "whatsapp.message",
    "Olá, gostaria de informações sobre os tratamentos da Kosmedico."
  );
  const msg = extraText ? `${base}\n\n${extraText}` : base;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
};

/**
 * Build a wa.me URL that carries the lead form payload as a pre-filled
 * message so the clinic team receives all the details on WhatsApp in
 * addition to the backend email.
 */
export const buildLeadWhatsAppUrl = (lead) => {
  const t = (k, fb) => i18n.t(k, fb);
  const lines = [
    t("whatsapp.lead_intro", "Olá! Gostaria de agendar uma avaliação."),
    "",
    `${t("form.name", "Nome")}: ${lead.name || "-"}`,
    `${t("form.phone", "Telefone")}: ${lead.phone || "-"}`,
    `${t("form.email", "E-mail")}: ${lead.email || "-"}`,
  ];
  if (lead.appointment_date) {
    lines.push(`${t("whatsapp.lead_date", "Data preferida")}: ${lead.appointment_date}`);
  }
  if (lead.appointment_time) {
    lines.push(`${t("whatsapp.lead_time", "Hora preferida")}: ${lead.appointment_time}`);
  }
  if (lead.treatment) {
    lines.push(`${t("whatsapp.lead_treatment", "Tratamento")}: ${lead.treatment}`);
  }
  const msg = lines.join("\n");
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
};

/** Track a click to WhatsApp from an arbitrary source (CTA, button, header...). */
export const trackWhatsAppClick = (source) => {
  trackEvent("whatsapp_start_chat", {
    value: WHATSAPP_VALUE_CHF,
    currency: CURRENCY,
    source,
    number: WHATSAPP_NUMBER,
    location: typeof window !== "undefined" ? window.location.pathname : "",
  });
};
